import { render } from "./BelegModalDelete.pug?vue&type=template&id=2f1d411f&lang=pug"
import script from "./BelegModalDelete.js?vue&type=script&lang=js"
export * from "./BelegModalDelete.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__